(() => {
  const installationKey = Symbol.for('mw-stkt.services-transfer.installed');
  if (document[installationKey]) return;

  const handleClick = (event) => {
    if (event.defaultPrevented || event.button > 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) {
      return;
    }

    const origin = event.target instanceof Element ? event.target : null;
    const button = origin?.closest('[data-mw-stkt-service-transfer]');
    if (!button) return;

    const title = button.dataset.serviceTitle?.trim() || '';
    const range = button.dataset.serviceRange?.trim() || '';
    const solution = [title, range].filter(Boolean).join(' – ');
    if (!solution) return;

    const transferEvent = new CustomEvent('mw-stkt:service-transfer', {
      bubbles: false,
      cancelable: true,
      detail: {
        target: button.dataset.mwStktContactTarget || '#kontakt',
        solution,
      },
    });

    if (!document.dispatchEvent(transferEvent)) event.preventDefault();
  };

  document.addEventListener('click', handleClick);
  document[installationKey] = true;
})();
